import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'
import { goToPrevioIDLogin } from '~/composables/PrevioID'
import { useAuthenticationStore } from '~/store/authentication'

const authorization = async (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext,
): Promise<void> => {
  const authentication = useAuthenticationStore.value

  if (!authentication.accessToken || !authentication.refreshToken) {
    goToPrevioIDLogin()

    return
  }

  return next()
}

export default authorization
